<div class="col-sm-12 wl-dashboard-retention">
  <p-table [showGridlines]="true" #retentionGrid [ngClass]="showRetentionDetails ? 'wl-responsive-prime-datatable' : 'wl-responsive-prime-datatable body-hidden'" [value]="retentionDetails" [paginator]="false">
    <ng-template pTemplate="sorticon" field="col.field" let-sortOrder>
      <SortAltIcon *ngIf="sortOrder === 0">
        <span><i class="p-sortable-column-icon pi pi-fw pi-sort-alt" aria-hidden="true"></i></span>
      </SortAltIcon>
      <SortAmountUpAltIcon *ngIf="sortOrder === 1" [styleClass]="'p-sortable-column-icon'">
        <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-up-alt" aria-hidden="true"></i></span>
      </SortAmountUpAltIcon>
      <SortAmountDownIcon *ngIf="sortOrder === -1" [styleClass]="'p-sortable-column-icon'">
        <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-down" aria-hidden="true"></i></span>
      </SortAmountDownIcon>
    </ng-template>
    <ng-template pTemplate="header">
      <tr class="wl-text-left wl-prime-datatable-hidden-phone">
        <th style="width: 22%; text-align: left !important">
          <a (click)="toggleRetentionDetails()" [ngClass]="{ 'wl-dashboard-open-close-open': showRetentionDetails }"
            [hidden]="retentionDetails.length == 1">
            <span class="wl-dashboard-open-close-icon glyphicon glyphicon-chevron-up"></span>
            <span style="font-weight: bold" *ngIf="!showRetentionDetails">{{
              'dashboard.membership-activity.show-all-levels' | translate | titlecase
              }}</span>
            <span style="font-weight: bold" *ngIf="showRetentionDetails">{{
              'dashboard.membership-activity.show-totals-only' | translate | titlecase
              }}</span>
          </a>
        </th>
        <th>
          <span style="font-weight: bold">{{ 'dashboard.retention.accounts-billed' | translate | titlecase }}</span>
        </th>
        <th>
          <span style="font-weight: bold">{{ 'dashboard.retention.accounts-paid' | translate | titlecase }}</span>
        </th>
        <th>
          <span style="font-weight: bold">{{ 'dashboard.retention.member-retention' | translate | titlecase }}</span>
        </th>
        <th>
          <span style="font-weight: bold">{{ 'dashboard.retention.amount-billed' | translate | titlecase }}</span>
        </th>
        <th>
          <span style="font-weight: bold">{{ 'dashboard.retention.amount-paid' | translate | titlecase }}</span>
        </th>
        <th>
          <span style="font-weight: bold">{{ 'dashboard.retention.investment-retention' | translate | titlecase
            }}</span>
        </th>
      </tr>
      <tr class="wl-prime-datatable-hidden-tablet-and-bigger">
        <th style="text-align: left !important">
          <a (click)="toggleRetentionDetails()" [ngClass]="{ 'wl-dashboard-open-close-open': showRetentionDetails }">
            <span class="wl-dashboard-open-close-icon glyphicon glyphicon-chevron-down"></span>
            <span style="font-weight: bold" *ngIf="!showRetentionDetails">{{
              'dashboard.membership-activity.show-all-levels' | translate | titlecase
              }}</span>
            <span style="font-weight: bold" *ngIf="showRetentionDetails">{{
              'dashboard.membership-activity.show-totals-only' | translate | titlecase
              }}</span>
          </a>
        </th>
      </tr>
    </ng-template>
    <ng-template let-level pTemplate="body">
      <tr class="wl-text-left wl-prime-datatable-hidden-phone" [hidden]="!showRetentionDetails">
        <td style="text-align: left !important">{{ level.MembershipLevel }}</td>
        <td>{{ level.AccountsBilled }}</td>
        <td>{{ level.AccountsPaid }}</td>
        <td>{{ level.MemberRetention | atlasPercent: true }}</td>
        <td>{{ level.AmountBilled | currency }}</td>
        <td>{{ level.AmountPaid | currency }}</td>
        <td>{{ level.InvestmentRetention | atlasPercent: true }}</td>
      </tr>
      <tr class="wl-text-left wl-prime-datatable-hidden-tablet-and-bigger" [hidden]="!showRetentionDetails">
        <td style="text-align: left !important">
          <h4>{{ level.MembershipLevel }}</h4>
          <span style="font-weight: bold">{{ 'dashboard.retention.accounts-billed' | translate | titlecase
            }}:</span>&nbsp;&nbsp;{{
          level.AccountsBilled
          }}<br />
          <span style="font-weight: bold">{{ 'dashboard.retention.accounts-paid' | translate | titlecase
            }}:</span>&nbsp;&nbsp;{{
          level.AccountsPaid
          }}<br />
          <span style="font-weight: bold">{{ 'dashboard.retention.member-retention' | translate | titlecase
            }}:</span>&nbsp;&nbsp;{{
          level.MemberRetention | atlasPercent: true
          }}<br />
          <span style="font-weight: bold">{{ 'dashboard.retention.amount-billed' | translate | titlecase
            }}:</span>&nbsp;&nbsp;{{
          level.AmountBilled | currency
          }}<br />
          <span style="font-weight: bold">{{ 'dashboard.retention.amount-paid' | translate | titlecase
            }}:</span>&nbsp;&nbsp;{{
          level.AmountPaid | currency
          }}<br />
          <span style="font-weight: bold">{{ 'dashboard.retention.investment-retention' | translate | titlecase
            }}:</span>&nbsp;&nbsp;{{
          level.InvestmentRetention | atlasPercent: true
          }}<br />
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="footer">
      <tr class="wl-prime-datatable-hidden-phone footer">
        <td style="text-align: left !important">
          <span>{{ 'dashboard.retention.retention-totals' | translate | titlecase }}</span>
        </td>
        <td>
          <span>{{ retentionTotals.AccountsBilled }}</span>
        </td>
        <td>
          <span>{{ retentionTotals.AccountsPaid }}</span>
        </td>
        <td>
          <span>{{ retentionTotals.MemberRetention | atlasPercent: true }}</span>
        </td>
        <td>
          <span>{{ retentionTotals.AmountBilled | currency }}</span>
        </td>
        <td>
          <span>{{ retentionTotals.AmountPaid | currency }}</span>
        </td>
        <td>
          <span>{{ retentionTotals.InvestmentRetention | atlasPercent: true }}</span>
        </td>
      </tr>
      <tr class="wl-prime-datatable-hidden-tablet-and-bigger">
        <td style="text-align: left !important">
          <h4>{{ 'dashboard.retention.retention-totals' | translate | titlecase }}</h4>
          <span style="font-weight: bold">{{ 'dashboard.retention.accounts-billed' | translate | titlecase
            }}:</span>&nbsp;&nbsp;{{
          retentionTotals.AccountsBilled
          }}<br />
          <span style="font-weight: bold">{{ 'dashboard.retention.accounts-paid' | translate | titlecase
            }}:</span>&nbsp;&nbsp;{{
          retentionTotals.AccountsPaid
          }}<br />
          <span style="font-weight: bold">{{ 'dashboard.retention.member-retention' | translate | titlecase
            }}:</span>&nbsp;&nbsp;{{
          retentionTotals.MemberRetention | atlasPercent: true
          }}<br />
          <span style="font-weight: bold">{{ 'dashboard.retention.amount-billed' | translate | titlecase
            }}:</span>&nbsp;&nbsp;{{
          retentionTotals.AmountBilled | currency
          }}<br />
          <span style="font-weight: bold">{{ 'dashboard.retention.amount-paid' | translate | titlecase
            }}:</span>&nbsp;&nbsp;{{
          retentionTotals.AmountPaid | currency
          }}<br />
          <span style="font-weight: bold">{{ 'dashboard.retention.investment-retention' | translate | titlecase
            }}:</span>&nbsp;&nbsp;{{
          retentionTotals.InvestmentRetention | atlasPercent: true
          }}<br />
        </td>
      </tr>
    </ng-template>
  </p-table>

</div>